<template>
  <div class="container remove-padding-margin">
    <div class="fixed-top fixed-judul">
      <div class="row justify-content-center align-items-center set-row">
        <div class="col-md-1 col-sm-1 col-1 remove-padding" @click="back">
          <img src="../../assets/gambar/back-blue.svg" alt="" />
        </div>
        <div class="col-md-10 col-sm-10 col-10 text-center remove-padding">
          {{ `${isEditMode ? "Ubah" : "Tambah"} Paket E-Payment` }}
        </div>
        <div class="col-md-1 col-sm-1 col-1 remove-padding"></div>
      </div>
    </div>
    <main class="add-padding-default">
      <div class="flex-100">
        <div class="flex-1">
          <form action="">
            <div class="form-group set-margin">
              <div class="m-t-12" v-if="false">
                <div v-if="settingEpayment.jenisEmoney === 1" class="f-14 f-regular f-c-midgrey">
                  Masa Aktif: <span class="f-bold f-c-black">{{ settingEpayment.masaAktif }}</span>
                  <span class="dot"></span>
                  <button type="button" class="btn p-0 btn-link" @click="gotoSetting">
                    <span class="f-14 f-semi f-c-blue p-l-8">Lihat Detail</span>
                  </button>
                </div>
                <div v-if="settingEpayment.jenisEmoney === 1" class="f-12 f-regular f-c-midgrey m-d-12">
                  Tipe: {{ settingEpayment.JikaKedaluwarsa }} & Jika kedaluwarsa: {{ settingEpayment.tipe }}
                </div>
                <div v-if="settingEpayment.jenisEmoney === 2" class="f-14 f-regular f-c-midgrey m-d-12">
                  Masa Aktif: <span class="f-bold f-c-black">Selamanya</span>
                  <span class="dot"></span>
                  <button type="button" class="btn p-0 btn-link" @click="gotoSetting">
                    <span class="f-14 f-semi f-c-blue p-l-8">Lihat Detail</span>
                  </button>
                </div>
                <div v-if="!settingEpayment.jenisEmoney" class="f-14 f-regular f-c-midgrey m-d-12">
                  Masa aktif belum diatur
                  <span class="dot"></span>
                  <button type="button" class="btn p-0 btn-link" @click="gotoSetting">
                    <span class="f-14 f-semi f-c-blue p-l-8">Atur sekarang</span>
                  </button>
                </div>
              </div>
              <div class="separator" v-if="false"></div>
              <div class="m-t-12">
                <SOInputRegular
                  :title="'Nama Paket E-Payment'"
                  :placeholder="'E-Payment'"
                  :validation="'alphanumeric'"
                  :required="true"
                  v-model="ePayment.nama_paket"
                  @input="handleInput($event, 'nama_paket')"
                />
                <ErrorMessage class="error" label="Nama Paket E-Payment" :validation="$v.ePayment.nama_paket" />
              </div>
              <div class="form-row m-t-12">
                <div class="form-group col-md-12 col-sm-12 col-12">
                  <SOInputNominal
                    v-if="settingEpayment.jenisEmoney === 1"
                    :title="'Masa Aktif'"
                    :required="true"
                    :prefix-right="true"
                    :placeholder="'Isi masa aktif'"
                    :prefix="'Hari'"
                    :defaultValue="inputNominal.masaAktif.formatted"
                    v-model="inputNominal.masaAktif"
                    @input="handleNominalChange($event, 'masa_aktif')"
                  />
                  <ErrorMessage v-if="settingEpayment.jenisEmoney === 1" class="error" label="Saldo E-Payment" :validation="$v.ePayment.masa_aktif" />

                  <SOInputRegular
                    v-if="settingEpayment.jenisEmoney === 2"
                    :title="'Masa Aktif'"
                    :required="true"
                    :value="'Selamanya'"
                    :disabled="true"
                  />

                  <SOInputRegular
                    v-if="settingEpayment.jenisEmoney === ''"
                    :title="'Masa Aktif'"
                    :required="true"
                    :value="'Pengaturan belum diterapkan.'"
                    :disabled="true"
                  />

                  <div class="f-regular f-12 f-c-midgrey m-t-4">
                    <span v-if="settingEpayment.jenisEmoney === 1">
                      Tipe: {{ settingEpayment.tipe }} & Jika kedaluarsa: {{ settingEpayment.JikaKedaluwarsa }}.
                    </span>
                    <span v-if="settingEpayment.jenisEmoney === 2">
                      Masa aktif tidak akan kedaluwarsa.
                    </span>
                    <span v-if="settingEpayment.jenisEmoney === null">
                      Terapkan pengaturan terlebih dahulu.
                    </span>
                    <span class="f-c-blue" @click="showModalDetailMasaAktif">Lihat detail</span>
                  </div>
                </div>
              </div>
              <div class="form-row m-t-12">
                <div class="form-group col-md-12 col-sm-12 col-12">
                  <SOInputNominal
                    :title="'Saldo E-Payment'"
                    :required="true"
                    :prefix-left="true"
                    :placeholder="'Isi paket'"
                    :prefix="'Rp'"
                    :defaultValue="inputNominal.nominal.formatted"
                    v-model="inputNominal.nominal"
                    @input="handleNominalChange($event, 'nominal')"
                  />
                  <ErrorMessage class="error" label="Saldo E-Payment" :validation="$v.ePayment.nominal" />
                </div>
              </div>
              <div class="form-row m-t-12">
                <div v-if="!isShowBonus">
                  <SOButtonPlusLink
                    @action="(e) => toogleBonus(true)"
                    :id="'bonus-e-payment'"
                    :text="'Tambahkan Bonus'"
                  />
                </div>
                <div v-if="isShowBonus" class="form-group col-md-10 col-sm-10 col-10">
                  <SOInputNominal
                    :title="'Bonus Saldo'"
                    :required="false"
                    :prefix-left="true"
                    :placeholder="'Bonus Saldo'"
                    :prefix="'Rp'"
                    :defaultValue="inputNominal.bonus.formatted"
                    v-model="inputNominal.bonus"
                    @input="handleNominalChange($event, 'bonus_emoney')"
                  />
                </div>
                <div v-if="isShowBonus" class="form-group col-md-2 col-sm-2 col-2">
                  <div class="btn-right-close">
                    <SOButtonCloseLink
                      @action="(e) => toogleBonus(false)"
                      :id="'-deletebonus-e-payment'"
                      :with-text="false"
                    />
                  </div>
                </div>
              </div>
              <div class="form-row m-t-12">
                <div class="d-block col-md-12 col-sm-12 col-12">
                  <label class="f-regular f-16 f-c-black m-0">Harga paket:</label>
                  <label class="f-semi f-c-black f-16 m-0" style="padding-left: 5px">
                    {{ `Rp ${formatRupiah(ePayment.nominal.toString())}` }}
                  </label>
                </div>
                <div class="d-block col-md-12 col-sm-12 col-12">
                  <label class="f-regular f-12 f-c-midgrey m-0">
                    Total saldo yang diterima konsumen <b>Rp {{ formatRupiah(hrgBonus.toString()) }}</b>
                  </label>
                </div>
                <div class="d-block col-md-12 col-sm-12 col-12">
                  <label class="f-regular f-12 f-c-midgrey m-0">
                    Harga paket tidak termasuk bonus, hanya berdasarkan saldo utama.
                  </label>
                </div>
              </div>
            </div>
          </form>
        </div>
        <div class="button-lanjut">
          <button
            class="btn btn-login btn-long remove-margin"
            id="BtnCreateepayment"
            :disabled="isSubmit || !settingEpayment.jenisEmoney"
            @click="saveEPayment"
          >
            <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true" v-if="isSubmit"> </span>
            <span id="textBtn2" v-if="!isSubmit">
              Simpan
            </span>
          </button>
        </div>
      </div>
    </main>
    <div>
      <SOSlotModal :modal-title="`Masa Aktif E-Payment`" :modal-id="`modal-link-to-setting`" @close="closeModal">
        <template v-slot:modal-body>
          <div class="md-content">
            <div>
              <p class="note-setting">
                Masa aktif E-Payment belum diatur. Terapkan pengaturan masa aktif terlebih dahulu untuk menambah paket
                E-Payment.
              </p>
            </div>
          </div>
        </template>
        <template v-slot:modal-footer>
          <SOButton
            :outline="true"
            :full="true"
            :text="'Atur Masa Aktif'"
            :id="`link-to-setting`"
            @action="gotoSetting"
          />
        </template>
      </SOSlotModal>

      <SOSlotModal :modal-title="`Masa Aktif`" :modal-id="`modal-detail-masa-aktif`" @close="closeModalDetailMasaAktif">
        <template v-slot:modal-body>
          <div class="md-content" v-if="settingEpayment.jenisEmoney === 1">
            <div class="m-d-20">
              <div class="f-16 f-c-black">
                <span class="f-semi m-r-4">Tipe masa aktif:</span>
                {{ settingEpayment.tipe }}
              </div>
              <div class="f-regular f-14 f-c-midgrey">
                {{ getKeteranganMasaAktif(settingEpayment.tipe) }}
              </div>
            </div>

            <div>
              <div class="f-16 f-c-black">
                <span class="f-semi m-r-4">Jika kedaluwarsa:</span>
                {{ settingEpayment.JikaKedaluwarsa }}
              </div>
              <div class="f-regular f-14 f-c-midgrey">
                {{ getKeteranganKedaluarsa(settingEpayment.JikaKedaluwarsa) }}
              </div>
            </div>
          </div>

          <div class="md-content" v-if="settingEpayment.jenisEmoney === 2">
            <div class="f-16 f-c-black">
              <span class="f-semi m-r-4">Masa aktif selamanya</span>
              {{ settingEpayment.tipe }}
            </div>
            <div class="f-regular f-14 f-c-midgrey">
              Paket E-Payment tidak akan pernah kedaluwarsa.
            </div>
          </div>
        </template>
        <template v-slot:modal-footer>
          <div class="f-semi f-16 f-c-blue text-left" @click="gotoSetting">
            <img src="@/assets/icons/setting-blue.svg" alt="" class="m-r-4">
            Ubah pengaturan
          </div>
        </template>
      </SOSlotModal>
    </div>
  </div>
</template>

<script>
import SOInputRegular from "@/so-components/global/input/SOInputRegular";
import SOInputNominal from "@/so-components/global/input/SOInputNominal";
import SOButtonPlusLink from "@/so-components/global/ui/SOButtonPlusLink";
import SOButtonCloseLink from "@/so-components/global/ui/SOButtonCloseLink";
import connection from "@/store/utils/connection";
import {minValue, minLength, required, maxLength} from "vuelidate/lib/validators";
import ErrorMessage from "@/component-items/ErrorMessage";

import SOSlotModal from "@/so-components/global/slot/SOSlotModal";
import SOButton from "@/so-components/global/ui/SOButton";
import epaymentOptions from "@/modules/pengaturan-umum/static/epaymentOptions";
import options from "@/modules/pengaturan-umum/static/epaymentOptions";

export default {
  name: "EpaymentCreate",
  props: {
    setidoutletsetdeposit: {
      type: String,
      required: true,
    },
    idpayment: {
      type: String,
    },
  },
  components: {
    SOInputRegular,
    SOInputNominal,
    SOButtonPlusLink,
    SOButtonCloseLink,
    ErrorMessage,
    SOSlotModal,
    SOButton,
  },
  data() {
    return {
      ePayment: {
        idoutlet: this.setidoutletsetdeposit,
        nama_paket: "",
        masa_aktif: 0,
        nominal: 0,
        bonus_emoney: 0,
      },
      inputNominal: {
        nominal: {},
        masaAktif: {},
        bonus: {},
      },
      isShowBonus: false,
      isSubmit: false,
    };
  },
  validations: {
    ePayment: {
      nama_paket: {
        required,
        minLength: minLength(2),
      },
      nominal: {
        required,
        minValue: minValue(1),
      },
      masa_aktif: {
        required,
        minValue: minValue(1),
      }
    },
  },
  async mounted() {
    await this.backButtonPressed(this.back);
    // When Update
    await this.loadEPayment();

    if (this.settingEpayment.jenisEmoney === "") {
      $(`#modal-link-to-setting`).modal("show");
    }
  },
  computed: {
    apiEndPoint: function() {
      return {
        create: `${this.$baseurl}/masterData/epayment/create_paket_epayment`,
        update: `${this.$baseurl}/masterData/epayment/update_paket_epayment?idemoney=${this.idpayment}`,
        dataPayment: `${this.$baseurl}/masterData/meta/detail_epayment`,
      };
    },
    settingEpayment() {
      return this.$store.getters["pengaturanUmumModule/subTitle"].epayment;
    },
    isEditMode: function() {
      return this.idpayment ? true : false;
    },
    titleJenisDeposit: function() {
      return this.ePayment.jenis_emoney == 1 ? masaAktif.limited : masaAktif.unlimited;
    },
    hrgBonus: function() {
      return this.ePayment.nominal + this.ePayment.bonus_emoney;
    },
  },
  methods: {
    back() {
      this.$emit("backtolist");
    },
    closeModal() {
      $(`#modal-link-to-setting`).modal("hide");
    },
    showModalDetailMasaAktif() {
      $(`#modal-detail-masa-aktif`).modal("show");
    },
    closeModalDetailMasaAktif() {
      $(`#modal-detail-masa-aktif`).modal("hide");
    },
    gotoSetting() {
      this.$router.push({ name: "pengaturanUmum.paket_epayment", query: { idOutlet: this.setidoutletsetdeposit, epaymentRouteType: this.isEditMode ? "edit" : "create", id: this.idpayment } });
    },
    toogleBonus(val) {
      this.isShowBonus = val;

      if (!val) {
        this.ePayment.bonus_emoney = 0;
        this.inputNominal.bonus = {};
      }
    },
    handleInput(val, target) {
      this.ePayment[target] = val;
    },
    handleNominalChange(val, target) {
      this.ePayment[target] = val.raw;
    },
    errorValidation() {
      this.$v.ePayment.nama_paket.$touch();
      this.$v.ePayment.nominal.$touch();
      if (this.settingEpayment.jenisEmoney === 1) this.$v.ePayment.masa_aktif.$touch();

      return (this.settingEpayment.jenisEmoney === 1)
        ? this.$v.ePayment.nama_paket.$invalid || this.$v.ePayment.nominal.$invalid || this.$v.ePayment.masa_aktif.$invalid
        : this.$v.ePayment.nama_paket.$invalid || this.$v.ePayment.nominal.$invalid;
    },
    nominalFormat(value) {
      if (typeof value !== "number") {
        return {
          raw: 0,
          formatted: "0",
        };
      }

      return {
        raw: value,
        formatted: Number.isInteger(value)
          ? value.toString()
          : value
              .toFixed(2)
              .toString()
              .replace(".", ","),
      };
    },
    async saveEPayment() {
      if (this.errorValidation()) {
        this.$toast.error("Mohon Lengkapi Data Terlebih Dahulu");
        return;
      }
      this.isSubmit = true;
      try {
        let { ePayment } = this;
        let posted = new FormData();

        if (ePayment.nama_paket.length > 45) {
          this.$toast.error("Nama paket tidak boleh menelebihi 45 karakter");
          this.isSubmit = false;
          return;
        }

        Object.keys(ePayment).forEach(function(key) {
          posted.append(key, ePayment[key]);
        });

        let url = this.isEditMode ? this.apiEndPoint.update : this.apiEndPoint.create;

        const response = await connection.post(url, posted, connection.contentType.form);

        if (response.data.status === true) {
          this.isSubmit = false;
          this.back();
          this.$toast.success(response.data.msg);
        } else {
          this.isSubmit = false;
          this.$toast.error(response.data.msg);
        }
      } catch (e) {
        this.$catch_error_response(e);
        this.isSubmit = false;
      }
    },
    async loadEPayment() {
      if (!this.isEditMode) {
        return;
      }

      $("#loadingPage").addClass("overlayLoading");
      $("#loadingPage").show();
      try {
        const response = await connection.get(this.apiEndPoint.dataPayment, {
          idemoney: this.idpayment,
          idoutlet: this.setidoutletsetdeposit,
        });

        if (response.status === 200) {
          if (response.data.status === true) {
            let {
              data: { emoney, harga_emoney },
            } = response.data;
            let bonus = emoney.saldo - harga_emoney;

            this.ePayment.nama_paket = emoney.nama;
            this.ePayment.masa_aktif = emoney.masa_aktif / 1000 / (3600 * 24)
	        this.inputNominal.masaAktif = this.nominalFormat(emoney.masa_aktif / 1000 / (3600 * 24))
            // Saldo E-Payment
            this.ePayment.nominal = harga_emoney;
            this.inputNominal.nominal = this.nominalFormat(harga_emoney);
            // Bonus Saldo
            this.ePayment.bonus_emoney = bonus;
            this.isShowBonus = bonus > 0 ? true : false;
            this.inputNominal.bonus = this.nominalFormat(bonus);
          }
        } else {
          this.$toast.error(response.data.msg);
        }

        $("#loadingPage").hide();
        $("#loadingPage").removeClass("overlayLoading");
      } catch (error) {
        this.$catch_error_response(error);
        $("#loadingPage").removeClass("overlayLoading");
        $("#loadingPage").hide();
      }
    },
    getKeteranganMasaAktif(val) {
      let search = epaymentOptions.masaAktifPaket.options.filter(v => v.title === val)
      return search.length > 0 ? search[0].information : ""
    },
    getKeteranganKedaluarsa(val) {
      let search = epaymentOptions.jikaKedaluarsa.options.filter(v => v.title === val)
      return search.length > 0 ? search[0].information : ""
    }
  },
};
</script>

<style scoped>
.set-margin {
  margin-top: 70px;
}

.btn-right-close {
  margin-top: 33px;
  margin-left: 10px;
}

.text-small {
  line-height: 18px;
  letter-spacing: -0.02em;
  color: #6f7287;
}
span.dot {
  display: inline-block;
  width: 4px;
  margin-right: -4px;
  margin-left: 5px;
  height: 4px;
  border-radius: 9999px;
  background-color: #c8d0dd;
  margin-bottom: 3px;
}

.note-setting {
  margin-bottom: -16px;
}
</style>
